import { TeamActivity } from './TeamActivity';
import {
  type TeamActivityPageProps,
  TeamActivityProvider,
} from './TeamActivityContext';

export const TeamActivityPage = (props: TeamActivityPageProps) => {
  return (
    <TeamActivityProvider {...props}>
      <TeamActivity />
    </TeamActivityProvider>
  );
};
